export function InsertImage (pEditor, pImage)
{
  let isImageThumbnail = false;


  function queryInsertImageState ()
  {
    let ret = false;

    pImage.currentImage = pImage.getCurrentImage();

    if (pImage.currentImage)
    {
      ret = pEditor.artText.isArtTextImage(pImage.currentImage) ? false : (!pImage.currentImage.getAttribute('data-anchorIndex') && (!pImage.currentImage.getAttribute('alt') || !(/^UserCustomScript-\d+$/i).test(pImage.currentImage.getAttribute('alt'))));
    }

    return ret;
  }


  this.openInsertImageDialog = pButton =>
  {
    let thumbnailLink,
        currentRange;

    pEditor.undoRedo.isStopSaveUndo = true;
    pEditor.contentChecker.setExcludeWordCheck();

    pEditor.range.save();

    pImage.currentImage = pImage.getCurrentImage();

    if (pImage.currentImage && !pEditor.artText.isArtTextImage(pImage.currentImage) && !pImage.currentImage.getAttribute('data-anchorIndex') && (!pImage.currentImage.getAttribute('alt') || !(/^UserCustomScript-\d+$/i).test(pImage.currentImage.getAttribute('alt'))))
    {
      isImageThumbnail = false;
      thumbnailLink = pImage.getThumbnailLink(pImage.currentImage);

      if (thumbnailLink)
      {
        isImageThumbnail = true;
      }

      if (!BEditor.browser.isIE)
      {
        pImage.currentImage.setAttribute('data-wacurrentimage', '1');
      }
    }
    else
    {
      if (!BEditor.browser.isIE && pEditor.queryStatePositionAbsolute(pButton, null))
      {
        currentRange = pEditor.range.getCurrent();

        if (currentRange)
        {
          currentRange.insertNode(currentRange.createContextualFragment('<span data-wainsertpointer="1"></span>'));
        }
      }
    }

    if (WA.isCaaS)
    {
      pEditor.pDialog = (pButton && pButton.getDialog()) ? pButton.getDialog() : BEditor.Dialogs['Resource'].dialog;

      if (!pEditor.pDialog)
      {
        return false;
      }

      pEditor.pDialog.ResourceInsert.addHandler(insertImage);
      pEditor.pDialog.Hide.addHandler(insertImageDialogClosed);
      pEditor.pDialog.showInsertResourceDialog({ dialogMode: BEditor.UI.InsertResourceDialog.Modes.Image });
    }
    else
    {
      var onSave = function (params)
      {
        //pEditor.pThis.execCommand(null, 'insertImage', params);
        insertImage(null, params);
      };

      var onCancel = function()
      {
        pEditor.afterCloseDialog();
      };

      window.BEditor.openDialog('openInsertDocumentDialog', onSave, onCancel, { mode: 'InsertImage' });
    }

    pEditor.afterOpenDialog();
  };


  function insertImage (sender, args)
  {
    let imgTag = '',
        imgTagEnd = '',
        isLink = false,
        linkId = 'idLink_' + (new Date()).getTime(),
        sParameters =
        {
          title: '',
          width: '',
          height: '',
          border: '0',
          align: null,
          marginTop: '7',
          marginRight: '7',
          marginBottom: '7',
          marginLeft: '7',
          isThumbnail: false,
          text: '',
          isAnyFileUploaded: false,
          isKeepOriginalImageSize: false
        },
        currentSelection,
        currentRange,
        rangeElement,
        isAbsElement = false,
        insertPoint;

    if (WA.isCaaS)
    {
      if (pEditor.pDialog)
      {
        pEditor.pDialog.ResourceInsert.removeHandler(insertImage);
        pEditor.pDialog.Hide.removeHandler(insertImageDialogClosed);
        sParameters.src = args.selectedItem.src;
        pEditor.closeDialog();
      }
      else
      {
        return false;
      }
    }
    else
    {
      sParameters.src = args.fullPath;
      pEditor.afterCloseDialog();
    }

    if (!BEditor.browser.isIE && pImage.currentImage && !pImage.currentImage.parentNode)
    {
      pImage.currentImage = pEditor.iFrameDoc.body.querySelector('IMG[data-wacurrentimage]');
    }

    insertPoint = pEditor.iFrameDoc.body.querySelector('SPAN[data-wainsertpointer]');

    if (insertPoint)
    {
      insertPoint.removeAttribute('data-wainsertpointer');
      insertPoint.setAttribute('data-wainsertpointerforimage', '1');
    }

    if (sParameters)
    {
      waMetricsGlobalHandler({module: 'InsertResourceDialog', object: 'ImageDialog', operation: 'Use'});

      if (sParameters.isAnyFileUploaded && sParameters.isKeepOriginalImageSize)
      {
        waMetricsGlobalHandler({module: 'InsertResourceDialog', object: 'ImageDialog', operation: 'KeepOriginalSize'});
      }

      if (!pImage.currentImage)
      {
        waMetricsGlobalHandler({module: 'InsertResourceDialog', object: 'ImageDialog', operation: 'Insert'});
        waMetricsGlobalHandler({module: 'InsertResourceDialog', object: 'ImageDialog', operation: (sParameters.isAnyFileUploaded ? 'InsertNew' : 'InsertExisting')});

        currentSelection = pEditor.range.selection.getCurrent();
        currentRange = pEditor.range.getCurrent();

        if (currentRange)
        {
          if (sParameters.isThumbnail || sParameters.text)
          {
            imgTag += '<a ' + (isGecko ? 'id="' + linkId + '" ' : '') + 'href="' + (sParameters.src.replace(/\?width=\d+&height=\d+/i, '')) + '" title="' + sParameters.title + '" target="_blank">';
            isLink = true;
          }

          if (sParameters.text)
          {
            imgTag += sParameters.text;
          }
          else
          {
            imgTag += '<img src="' + sParameters.src + '"' + ' alt="' + sParameters.title + '" title="' + sParameters.title + '"';

            if (sParameters.width)
            {
              imgTag += ' width="' + sParameters.width + '"';
            }

            if (sParameters.height)
            {
              imgTag += ' height="' + sParameters.height + '"';
            }

            imgTag += ' border="' + sParameters.border + '"';

            imgTagEnd += (sParameters.align) ? ' align="' + sParameters.align + '"' : '';
            imgTagEnd += (sParameters.align) ? ' style="margin: ' + sParameters.marginTop + 'px ' + sParameters.marginRight + 'px ' + sParameters.marginBottom + 'px ' + sParameters.marginLeft + 'px;"' : '';
            imgTagEnd += '>';
          }

          if (sParameters.isThumbnail || sParameters.text)
          {
            imgTagEnd += '</a>';
          }

          if (pEditor.isEditorInHeader)
          {
            rangeElement = pEditor.layer.helpers.isRangeElementPositionAbsolute();

            if (!rangeElement)
            {
              imgTag += ' style="position: absolute; top: 17px;';

              switch (sParameters.align)
              {
                case 'left':
                  imgTag += ' left: 0px;';
                  break;

                case 'right':
                  imgTag += ' right: 0px;';
                  break;

                default:
                  imgTag += ' left: 17px;';
              }

              imgTag += ' z-index: ' + (pEditor.layer.coAbsElementZIndex++) + '">';
              isAbsElement = true;
            }
            else if (rangeElement.nodeName === 'DIV' && rangeElement.innerHTML.replace(/(<br>|\s|&nbsp;)/ig, '') === '')
            {
              imgTag += ' style="position: absolute; top: ' + rangeElement.offsetTop + 'px;';

              switch (sParameters.align)
              {
                case 'left':
                  imgTag += ' left: 0px;';
                  break;

                case 'right':
                  imgTag += ' right: 0px;';
                  break;

                default:
                  imgTag += ' left: ' + rangeElement.offsetLeft + 'px;';
              }

              imgTag += ' z-index: ' + (pEditor.layer.coAbsElementZIndex++) + '">';
              isAbsElement = true;
              rangeElement.parentNode.removeChild(rangeElement);
            }
            else if (rangeElement.nodeName === 'IMG')
            {
              rangeElement.src = sParameters.src;
              rangeElement.title = sParameters.title;
              rangeElement.alt = sParameters.title;

              if (sParameters.width)
              {
                rangeElement.width = sParameters.width;
              }
              else
              {
                rangeElement.removeAttribute('width');
              }

              if (sParameters.height)
              {
                rangeElement.height = sParameters.height;
              }
              else
              {
                rangeElement.removeAttribute('height');
              }

              rangeElement.border = sParameters.border;

              if (pEditor.undoRedo.isStopSaveUndo)
              {
                pEditor.undoRedo.saveUndoDo();
                pEditor.undoRedo.isStopSaveUndo = false;
              }

              return true;
            }
            else
            {
              imgTag += imgTagEnd;
            }
          }
          else
          {
            imgTag += imgTagEnd;
          }

          if (BEditor.browser.isIE)
          {
            if (currentSelection && currentSelection.type.toUpperCase() === 'CONTROL')
            {
              currentRange.item(0).outerHTML = imgTag;
            }
            else
            {
              currentRange.pasteHTML(imgTag);
            }
          }
          else
          {
            if (insertPoint)
            {
              insertPoint.outerHTML = imgTag;
            }
            else
            {
              currentRange.deleteContents();
              pEditor.contentCleaner.removeEmptyP();
              currentRange.insertNode(currentRange.createContextualFragment(imgTag));
            }

            selectImage(false);

            if (isAbsElement)
            {
              pEditor.absElementsFixer.fixAllAbsElements(true);
            }
          }
        }
      }
      else
      {
        changeImage(pImage.currentImage);
      }

      pImage.objectFactory.checkAllImages();
      pEditor.range.save();
    }

    if (pEditor.undoRedo.isStopSaveUndo)
    {
      pEditor.undoRedo.saveUndoDo();
      pEditor.undoRedo.isStopSaveUndo = false;
    }

    function changeImage (el)
    {
      waMetricsGlobalHandler({module: 'InsertResourceDialog', object: 'ImageDialog', operation: 'Replace'});
      waMetricsGlobalHandler({module: 'InsertResourceDialog', object: 'ImageDialog', operation: (sParameters.isAnyFileUploaded ? 'ReplaceNew' : 'ReplaceExisting')});

      el.src = sParameters.src;
      el.alt = sParameters.title;
      el.title = sParameters.title;

      if (sParameters.width)
      {
        el.width = sParameters.width;
      }
      else
      {
        el.removeAttribute('width');
      }

      if (sParameters.height)
      {
        el.height = sParameters.height;
      }
      else
      {
        el.removeAttribute('height');
      }

      if (sParameters.align)
      {
        el.setAttribute('align', sParameters.align);
      }
      else
      {
        el.removeAttribute('align');
      }

      el.border = sParameters.border;
      el.removeAttribute('style');

      if (isImageThumbnail && el.parentNode.nodeName.toUpperCase() === 'A')
      {
        el.parentNode.setAttribute('href', sParameters.src.replace(/\?width=\d+&height=\d+/i, ''));

        isLink = true;
        selectImage();
      }
    }

    function selectImage (isAllBrowsers)
    {
      let linkElement;

      if (isLink)
      {
        if (BEditor.browser.isGecko || isAllBrowsers)
        {
          linkElement = pEditor.iFrameDoc.getElementById(linkId);

          if (BEditor.browser.isIE)
          {
            currentRange = pEditor.iFrameDoc.body.createTextRange();
            currentRange.moveToElementText(linkElement);
            currentRange.select();
          }
          else
          {
            if (linkElement)
            {
              currentSelection.removeAllRanges();
              currentRange = pEditor.iFrameDoc.createRange();
              currentRange.selectNode(linkElement);
              currentRange.collapse(false);
              currentSelection.addRange(currentRange);
              linkElement.removeAttribute('id');
            }
          }
        }
      }
    }
  }


  function insertImageDialogClosed (sender, args)
  {
    pEditor.pDialog.ResourceInsert.removeHandler(insertImage);
    pEditor.pDialog.Hide.removeHandler(insertImageDialogClosed);

    waMetricsGlobalHandler({module: 'InsertResourceDialog', object: 'ImageDialog', operation: (args.isAnyFileUploaded ? 'UploadOnly' : 'Nothing')});

    pEditor.afterCloseDialog();
  }


  this.queryInsertImageState = queryInsertImageState;
  this.insertImage = insertImage;
}